import { render, staticRenderFns } from "./Movimentacao.vue?vue&type=template&id=1cfae391&scoped=true&"
import script from "./Movimentacao.vue?vue&type=script&lang=js&"
export * from "./Movimentacao.vue?vue&type=script&lang=js&"
import style0 from "./Movimentacao.vue?vue&type=style&index=0&id=1cfae391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfae391",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
